import { render, staticRenderFns } from "./linkMini.vue?vue&type=template&id=0be54758&scoped=true&"
import script from "./linkMini.vue?vue&type=script&lang=js&"
export * from "./linkMini.vue?vue&type=script&lang=js&"
import style0 from "./linkMini.vue?vue&type=style&index=0&id=0be54758&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be54758",
  null
  
)

export default component.exports